import styled from "styled-components";

export const ContainerStyled = styled.div`
  padding: 4px;
`;
